export const convertToBrazilianReal = (cents: number): string => {
  if (cents === null || cents === undefined || cents === 0) return null;
  const value = cents / 100;

  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(value);
};
